import { createContext, useContext, useEffect, useState } from "react";
import { IngressosTabs } from "./IngressosTabs";
import { useTab } from "../../store/useTab";

interface TabProps {
  currentTab: string;
  setCurrentTab: (tab: string) => void;
}
const TabContext = createContext({} as TabProps);

export function Ingressos() {
  const setTab = useTab((store) => store.setTab);
  const [currentTab, setCurrentTab] = useState<string>("tab1");

  useEffect(() => {
    setTab("Ingressos");
  }, [setTab]);

  return (
    <TabContext.Provider value={{ currentTab, setCurrentTab }}>
      <header className="mb-2 border-b border-zinc-200/80 pb-6 dark:border-zinc-800">
        <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 dark:text-white sm:text-3xl">
          Ingressos
        </h1>
        <p className="mt-1 max-w-2xl text-sm text-zinc-600 dark:text-zinc-400">
          Tipos de ingresso e configurações relacionadas aos eventos.
        </p>
      </header>
      <IngressosTabs />
    </TabContext.Provider>
  );
}

export const useTabContext = () => useContext(TabContext);
